var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DcfSdkEnumsObj } from "@payair/srci-logic-sdk/models/DcfSdkEnum";
import { ResultStatusObj } from "@payair/srci-logic-sdk/models/ResultStatus";
import { SrciScreenEnumsObj } from "../../enums/internal/SrciScreenEnum";
import { SrciEventTypeEnumsObj } from "../../enums/SrciEventTypeEnum";
import { ErrorCodesObj, SomethingWentWrongErrorCodesObj } from "../../helpers/ErrorMapper";
import { updateScreen, getInitScreen } from "../SrciSdk";
import { getErrorInfoMessageModel, getPaymentMethod } from "./SrciUi";
import { defineCustomElement as defineOtpScreen, OtpScreen } from "@payair/srci-ui-sdk/custom-elements/otp-screen";
/** @internal */
var SrciOtpScreen = /** @class */ (function () {
    function SrciOtpScreen(srciLogic, languageHandler) {
        var _this = this;
        this.requestOtp = function (commonState, validationChannelId) { return __awaiter(_this, void 0, void 0, function () {
            var operation;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        operation = (_a = commonState.pendingOtpSendOperation) !== null && _a !== void 0 ? _a : "INITIAL";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.srciLogic.initiateIdentityValidation(validationChannelId, commonState.defaultDcfSdk, operation)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        commonState.pendingOtpSendOperation = undefined;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getOtpScreen = function (commonState, mastercardState, visaState, locale, paymentMethod, isCloseButtonEnabled) { return __awaiter(_this, void 0, void 0, function () {
            var otpScreen, validationChannelId, iivResponse, _a, iivResponseValue;
            var _this = this;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!locale) {
                            return [2 /*return*/, undefined];
                        }
                        otpScreen = new OtpScreen();
                        otpScreen.locale = locale;
                        otpScreen.paymentMethod = getPaymentMethod(mastercardState, visaState, paymentMethod);
                        otpScreen.isChangeChannel = commonState.defaultDcfSdk === DcfSdkEnumsObj.MASTERCARD;
                        otpScreen.rememberMe = commonState.rememberMeConsent;
                        otpScreen.rememberMeOnChange = function (rememberMe) {
                            commonState.rememberMeConsent = rememberMe;
                            otpScreen.rememberMe = rememberMe;
                        };
                        otpScreen.changeUserButtonOnClick = function () {
                            return _this.changeUserButtonOnClick(commonState, mastercardState, visaState);
                        };
                        otpScreen.resendButtonOnClick = function () { return _this.resendButtonOnClick(commonState, otpScreen); };
                        otpScreen.continueButtonOnClick = function (otp) {
                            return _this.continueButtonOnClick(commonState, mastercardState, visaState, otpScreen, otp);
                        };
                        if (isCloseButtonEnabled === true) {
                            otpScreen.closeButtonOnClick = function () {
                                return _this.srciLogic.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_BY_USER);
                            };
                        }
                        validationChannelId = this.getValidationChannelId(commonState);
                        if (commonState.selectedOtpChannel && !validationChannelId) {
                            this.handleOtpError(ErrorCodesObj.OTP_SEND_FAILED, otpScreen);
                            return [2 /*return*/, otpScreen];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.requestOtp(commonState, validationChannelId)];
                    case 2:
                        iivResponse = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _c.sent();
                        this.handleOtpError(ErrorCodesObj.OTP_SEND_FAILED, otpScreen);
                        return [2 /*return*/, otpScreen];
                    case 4:
                        iivResponseValue = iivResponse.value;
                        if (iivResponse.status !== ResultStatusObj.FULFILLED) {
                            this.handleOtpError((_b = iivResponse.reason) === null || _b === void 0 ? void 0 : _b.reason, otpScreen);
                            return [2 /*return*/, otpScreen];
                        }
                        else if (!(iivResponseValue === null || iivResponseValue === void 0 ? void 0 : iivResponseValue.maskedValidationChannel)) {
                            this.handleOtpError(ErrorCodesObj.OTP_SEND_FAILED, otpScreen);
                            return [2 /*return*/, otpScreen];
                        }
                        this.handleInitiateIdentityValidationResponse(commonState, iivResponseValue, otpScreen);
                        return [2 /*return*/, otpScreen];
                }
            });
        }); };
        this.handleInitiateIdentityValidationResponse = function (commonState, iivResponseValue, otpScreen) {
            otpScreen.maskedValidationChannel = iivResponseValue.maskedValidationChannel;
            var supportedChannels = iivResponseValue.supportedValidationChannels;
            if (supportedChannels) {
                commonState.identityValidationChannels = supportedChannels;
                var otpChannelData = { phone: "", email: "" };
                for (var _i = 0, supportedChannels_1 = supportedChannels; _i < supportedChannels_1.length; _i++) {
                    var supportedChannel = supportedChannels_1[_i];
                    if (supportedChannel.identityType === "EMAIL_ADDRESS") {
                        otpChannelData.email = supportedChannel.maskedValidationChannel;
                    }
                    else if (supportedChannel.identityType === "MOBILE_PHONE_NUMBER") {
                        otpChannelData.phone = supportedChannel.maskedValidationChannel;
                    }
                }
                if (!otpChannelData.email.length && !otpChannelData.phone.length) {
                    updateScreen(SrciScreenEnumsObj.LOGIN_SCREEN);
                }
                commonState.otpChannelsData = otpChannelData;
            }
        };
        this.getValidationChannelId = function (commonState) {
            var _a;
            if (commonState.selectedOtpChannel && commonState.identityValidationChannels) {
                return (_a = commonState.identityValidationChannels.find(function (identityValidationChannel) {
                    return identityValidationChannel.maskedValidationChannel === commonState.selectedOtpChannel;
                })) === null || _a === void 0 ? void 0 : _a.validationChannelID;
            }
            return undefined;
        };
        this.changeUserButtonOnClick = function (commonState, mastercardState, visaState) {
            _this.srciLogic.resetConsumerIdentity(commonState, mastercardState, visaState);
            updateScreen(SrciScreenEnumsObj.NEW_USER_SCREEN);
        };
        this.resendButtonOnClick = function (commonState, otpScreen) { return __awaiter(_this, void 0, void 0, function () {
            var otpResentString, infoMessage, iivResponse, _a, errorModel;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        otpResentString = this.languageHandler.getString(ErrorCodesObj.OTP_RESENT);
                        infoMessage = {
                            infoType: "ALERT",
                            infoMessage: otpResentString ? otpResentString : "",
                        };
                        otpScreen.majorError = infoMessage;
                        if (commonState.defaultDcfSdk && commonState.defaultDcfSdk === DcfSdkEnumsObj.MASTERCARD) {
                            commonState.pendingOtpSendOperation = "RESEND";
                            updateScreen(SrciScreenEnumsObj.OTP_CHANNEL);
                            return [2 /*return*/];
                        }
                        commonState.pendingOtpSendOperation = "RESEND";
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.requestOtp(commonState)];
                    case 2:
                        iivResponse = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _d.sent();
                        this.handleOtpError(ErrorCodesObj.OTP_SEND_FAILED, otpScreen);
                        return [2 /*return*/];
                    case 4:
                        if (iivResponse.status !== ResultStatusObj.FULFILLED) {
                            errorModel = getErrorInfoMessageModel("ERROR", [{ reason: (_b = iivResponse.reason) === null || _b === void 0 ? void 0 : _b.reason }], this.languageHandler);
                            otpScreen.majorError = errorModel;
                            otpScreen.isLoading = false;
                        }
                        else if (!((_c = iivResponse.value) === null || _c === void 0 ? void 0 : _c.maskedValidationChannel)) {
                            this.handleOtpError(ErrorCodesObj.OTP_SEND_FAILED, otpScreen);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.continueButtonOnClick = function (commonState, mastercardState, visaState, otpScreen, otp) { return __awaiter(_this, void 0, void 0, function () {
            var completeIdentityValidationResponse, reason, idToken, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        otpScreen.isLoading = true;
                        otpScreen.minorError = undefined;
                        if (!otp) {
                            otpScreen.minorError = this.languageHandler.getString(ErrorCodesObj.OTP_EMPTY);
                            otpScreen.isLoading = false;
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.srciLogic.completeIdentityValidation(otp, commonState.defaultDcfSdk)];
                    case 2:
                        completeIdentityValidationResponse = _c.sent();
                        if (completeIdentityValidationResponse.status !== ResultStatusObj.FULFILLED) {
                            reason = (_b = completeIdentityValidationResponse.reason) === null || _b === void 0 ? void 0 : _b.reason;
                            this.handleOtpError(reason, otpScreen);
                            return [2 /*return*/];
                        }
                        else if (!completeIdentityValidationResponse.value || !completeIdentityValidationResponse.value.idToken) {
                            this.handleOtpError(SomethingWentWrongErrorCodesObj.SERVER_ERROR, otpScreen);
                            return [2 /*return*/];
                        }
                        idToken = completeIdentityValidationResponse.value.idToken;
                        return [4 /*yield*/, this.handleCompleteIdentityValidationResponse(commonState, mastercardState, visaState, idToken, otpScreen)];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _c.sent();
                        this.handleOtpError(SomethingWentWrongErrorCodesObj.SERVER_ERROR, otpScreen);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.handleCompleteIdentityValidationResponse = function (commonState, mastercardState, visaState, idToken, otpScreen) { return __awaiter(_this, void 0, void 0, function () {
            var _a, isMastercardProfileDefined, isVisaProfileDefined, profileErrors, initScreen;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (commonState.defaultDcfSdk === DcfSdkEnumsObj.MASTERCARD) {
                            mastercardState.idTokens = [idToken];
                        }
                        else if (commonState.defaultDcfSdk === DcfSdkEnumsObj.VISA) {
                            visaState.idTokens = [idToken];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.srciLogic.getProfilesAndUpdateState(commonState, mastercardState, visaState)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _d.sent();
                        otpScreen.majorError = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.PROFILE_LOAD_FAILED }], this.languageHandler);
                        otpScreen.isLoading = false;
                        return [2 /*return*/];
                    case 4:
                        isMastercardProfileDefined = ((_b = mastercardState.getProfileResponse) === null || _b === void 0 ? void 0 : _b.profiles) && mastercardState.getProfileResponse.profiles.length > 0;
                        isVisaProfileDefined = ((_c = visaState.getProfileResponse) === null || _c === void 0 ? void 0 : _c.profiles) && visaState.getProfileResponse.profiles.length > 0;
                        profileErrors = commonState.profileErrors;
                        if (!isMastercardProfileDefined && !isVisaProfileDefined && profileErrors && profileErrors.length > 0) {
                            otpScreen.majorError = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.PROFILE_LOAD_FAILED }], this.languageHandler);
                            otpScreen.isLoading = false;
                            return [2 /*return*/];
                        }
                        else if (!isMastercardProfileDefined && !isVisaProfileDefined) {
                            otpScreen.majorError = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.EMPTY_PROFILE_LIST }], this.languageHandler);
                            otpScreen.isLoading = false;
                            return [2 /*return*/];
                        }
                        initScreen = getInitScreen(true);
                        updateScreen(initScreen);
                        return [2 /*return*/];
                }
            });
        }); };
        this.handleOtpError = function (reason, otpScreen) {
            switch (reason) {
                case ErrorCodesObj.CODE_EXPIRED: {
                    var codeExpiredString = _this.languageHandler.getString(ErrorCodesObj.CODE_EXPIRED);
                    var infoMessage = {
                        infoType: "ALERT",
                        infoMessage: codeExpiredString ? codeExpiredString : "",
                        clickableMessage: _this.languageHandler.getString(ErrorCodesObj.CODE_EXPIRED_SEND),
                        onClick: otpScreen.resendButtonOnClick,
                    };
                    otpScreen.majorError = infoMessage;
                    break;
                }
                case ErrorCodesObj.CODE_INVALID: {
                    otpScreen.minorError = _this.languageHandler.getString(ErrorCodesObj.CODE_INVALID);
                    break;
                }
                case ErrorCodesObj.OTP_SEND_FAILED: {
                    var reasonString = _this.languageHandler.getString(reason);
                    var infoMessage = {
                        infoType: "ALERT",
                        infoMessage: reasonString ? reasonString : "",
                        clickableMessage: _this.languageHandler.getString(ErrorCodesObj.OTP_SEND_FAILED_RESEND),
                        onClick: otpScreen.resendButtonOnClick,
                    };
                    otpScreen.majorError = infoMessage;
                    break;
                }
                default: {
                    otpScreen.majorError = getErrorInfoMessageModel("ERROR", [{ reason: reason }], _this.languageHandler);
                    break;
                }
            }
            otpScreen.isLoading = false;
        };
        this.srciLogic = srciLogic;
        this.languageHandler = languageHandler;
        defineOtpScreen();
    }
    return SrciOtpScreen;
}());
export { SrciOtpScreen };
